const BannerCurveDecoration = () => {
  return (
    <div
      className="pointer-events-none absolute inset-0 overflow-hidden"
      aria-hidden="true"
    >
      <div className="absolute -bottom-1/3 -left-1/4 h-[150%] w-[65%] rounded-full bg-secondary-pink-50 opacity-70 md:-left-[10%] md:w-[40%]" />
      <div className="absolute -bottom-1/4 -left-[8%] h-[120%] w-[45%] rounded-full bg-white/70 md:left-[5%] md:w-[28%]" />
    </div>
  );
};

export default BannerCurveDecoration;
